<template>
  <div class="ServiceSupport">
    <div class="ProductImge">
      <el-carousel :interval="5000" height="280px">
        <el-carousel-item v-for="(item,index) in swiperList" :key="index">
          <img :src="item.showImgUrl" alt="">
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="introductionBox">
      <div class="introduction-mian" v-if="ProductList.length>0">
        <div class="introduction_L">
          <div class="introductiontitle" @click="recovery">合作伙伴</div>
          <div class="introductionItem">
            <el-menu :default-active="currentTwo" v-for="(item,index) in ProductList" :key="index" class="el-menu-vertical-demo" @open="handleOpen" @select="handleselect" background-color="#4390D9" text-color="#fff" active-text-color="#1373CF">
              <el-submenu :index="item.indexs">
                <template slot="title">
                  <span>{{item.navigationTwoClassPojo.twoClassName}}</span>
                </template>
                <el-menu-item :index="((index+1)+'-'+(pndex+1))" v-for="(ptem,pndex) in item.contentPojos" :key="pndex">{{ptem.oneTitle}}</el-menu-item>
              </el-submenu>
            </el-menu>
          </div>
        </div>

        <div v-if="!isselect">
          <div class="Product-introduction">
            <div class="Product-title">{{twoClassName}}</div>
            <!-- <div class="Product-title" v-if="currentTwo=='2'">产品介绍</div> -->
            <div class="Product-main" v-if="ContentList.length>0">
              <div class="Product-list">
                <div class="Product-item" v-for="(item,index) in ContentList" :key="index" @click="toDetail(item.contentId,item.oneTitle)">
                  <div class="Product-image">
                    <img :src="item.img" alt="">
                  </div>
                  <div class="Product-right">
                    <div class="Product-name">{{item.oneTitle}}</div>
                    <div class="Product-dsc">{{item.twoTitle}}</div>
                  </div>
                </div>
              </div>
              <div class="paginationBox">
                <el-pagination background layout="prev, pager, next" :total="totalElement"  @current-change="currentPage"></el-pagination>
              </div>
            </div>
            <div v-else>
              <el-empty :image-size="200"></el-empty>
            </div>
          </div>
        </div>
        <div v-if="isselect">
          <div class="introduction_r" v-if="currentTwo=='0'">
            <div class="introduction_nameBox">
              <div class="introduction_name">合作伙伴</div>
            </div>
            <div class="introduction_cont">
              <div class="Case-zoneBox" v-for="(item,index) in ProductList" :key="index">
                <div class="Image_titleBox" v-if="item.navigationTwoClassPojo.twoClassId!=-1 && item.navigationTwoClassPojo.twoClassId!=-2">
                  <div class="Image_title">{{item.navigationTwoClassPojo.twoClassName}}专区</div>
                  <!-- <div class="moretext">查看更多</div> -->
                </div>
                <div class="Product_ImageBox" v-if="item.contentPojos.length>0">
                  <div v-for="(ptem,pndex) in item.contentPojos" :key="pndex" class="ImageItemWrap">
                    <div class="ImageItem">
                      <img :src="ptem.img" alt="">
                      <div class="animationItem" @click="toDetail(ptem.contentId,ptem.oneTitle)">
                        <div class="link_icon"><img src="../assets/img/icon_link.png" alt=""></div>
                        <div class="title">{{ptem.oneTitle}}</div>
                        <div class="dsrc">{{ptem.twoTitle}}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- <div v-else>
                  <el-empty :image-size="200"></el-empty>
                </div> -->
              </div>
            </div>
          </div>
          <div v-else>
            <div class="product-Item">
              <div class="introduction_r">
                <div class="introduction_nameBox">
                  <div class="introduction_name">{{contentName}}</div>
                </div>
              <div class="introduction_cont" v-html="ContentInfo.content"></div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      searchValue:"",
      currentIndex:-1,
      currentTwo:"0",
      // currentOne:0,
      ProductList:[],
      twoClassId:'',
      isselect:true,
      page:1,
      limit:10,
      ContentList:[],
      contentId:"",
      contentName:"",
      ContentInfo:{},
      totalElement:1,
      twoClassName:'',
      swiperList:[]
    }
  },
  mounted(){
    this.getProductList();
    this.getbackground()
  },
  methods:{
    getbackground(){
      let url = "/navigationController/front/searchNavigationShowImg"
      this.$axios.get(url,{
        params:{
          type:5
        }
      }).then(res=>{
        console.log(res)
        this.swiperList = res.data.data
      })
    },
    toDetail(id,oneTitle){
      // console.log(id)
      this.$router.push({path:'/product-Item',query:{contentId:id,contentName:oneTitle}})
    },
    currentPage(e){
      // console.log(e)
      this.page = e
      this.dropName()
    },
    getContentInfo(){
      let url = "/navigationController/front/searchContentInfo"
      this.$axios.get(url,{
        params:{
          contentId:this.contentId
        }
      }).then(res=>{
        console.log(res)
        const regex = new RegExp('<img', 'gi')
        res.data.data.content = res.data.data.content.replace(regex,`<img style="max-width: 100%; height: auto"`);
        this.ContentInfo = res.data.data
      })
    },
    dropName(){
      let url = "/navigationController/front/searchNavigationContentList"
      this.$axios.post(url,{
        twoClassId:this.twoClassId,
        page:this.page,
        limit:this.limit
      }).then(res=>{
        console.log(res)
        this.ContentList = res.data.data
        this.totalElement = res.data.totalElement
      })
    },
    getProductList(){
      let url = "/navigationController/front/searchNavigation"
      this.$axios.get(url,{
        params:{
          type:5
        }
      }).then(res=>{
        // console.log(res)
        let become = {"contentPojos":[],"navigationTwoClassPojo":{"twoClassName":"成为合作伙伴","twoClassId":-1,"type":5,"status":1}}
        let query = {"contentPojos":[],"navigationTwoClassPojo":{"twoClassName":"查询合作伙伴","twoClassId":-2,"type":5,"status":1}}
        res.data.data.push(become,query)
        let NewClassList = res.data.data;
        console.log(typeof NewClassList[2].navigationTwoClassPojo.twoClassId=="",'11')
        this.ProductList = NewClassList.map((cur,index)=>{
          cur.indexs = (index + 1).toString();
          return cur;
        })
      })
    },
    recovery(){
      this.currentTwo = "0"
      this.isselect = true
    },
    handleOpen(key, keyPath) {
      // console.log(typeof key, keyPath);
      this.currentTwo = key
      this.twoClassId = this.ProductList[(key-1)].navigationTwoClassPojo.twoClassId
      this.twoClassName = this.ProductList[key-1].navigationTwoClassPojo.twoClassName
      if(this.twoClassId==-1){
        this.$router.push({path:"/BecomeApartner"})
        return false
      }
      if(this.twoClassId==-2){
        this.$router.push({path:"/Query-partner",query:{contentName:this.twoClassName}})
        return false
      }
      this.isselect = false
      this.page = 1
      this.dropName()
    },
    handleselect(key, keyPath) {
      // console.log(key, keyPath);
      this.currentTwo = key
      let keys = key.split("-")
      // console.log(keys)
      this.contentId = this.ProductList[(keys[0]-1)].contentPojos[keys[1]-1].contentId
      this.contentName = this.ProductList[(keys[0]-1)].contentPojos[keys[1]-1].oneTitle
      this.getContentInfo();
      // console.log(this.contentId)
      this.isselect = true
    }
  }
}
</script>

<style scoped lang="less">
.product-Item {
  .introduction_r {
    width: calc(1200px - 304px);
    .introduction_nameBox {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 30px 0;
      // margin-bottom: 30px;
      border-bottom: 1px solid #e6e8ed;
      .introduction_name {
        font-size: 30px;
        font-family: NotoSansHans-Regular, NotoSansHans;
        font-weight: 400;
        color: #333333;
      }
      .inputBox {
        width: 360px;
        height: 36px;
        // background: #FFFFFF;
        border-radius: 4px;
        // border: 1px solid #1373CF;
      }
    }
    .introduction_cont {
      padding: 20px 0;
      .Customer_title {
        font-size: 18px;
        font-family: NotoSansHans-Medium, NotoSansHans;
        font-weight: 500;
        color: #333333;
      }
      .Customertext {
        font-size: 14px;
        font-family: NotoSansHans-Regular, NotoSansHans;
        font-weight: 400;
        color: #333333;
        line-height: 21px;
        padding: 30px 0;
        border-bottom: 1px solid #e6e8ed;
      }
      .Case-zoneBox {
        // padding: 10px 0;
        .Image_titleBox {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 20px 0;
          .Image_title {
            font-size: 18px;
            font-family: NotoSansHans-Medium, NotoSansHans;
            font-weight: 500;
            color: #333333;
          }
          .moretext {
            font-size: 14px;
            font-family: NotoSansHans-Regular, NotoSansHans;
            font-weight: 400;
            color: #1373cf;
            cursor: pointer;
          }
        }
        .Product_ImageBox {
          display: flex;
          flex-wrap: wrap;
          // justify-content: space-between;
          align-items: center;
          .ImageItemWrap {
            margin-right: 24px;
          }
          .ImageItemWrap:nth-child(3n + 3) {
            margin-right: 0;
          }
          .ImageItem {
            position: relative;
            width: 282px;
            height: 223px;
            background: #cfad13;
            margin-bottom: 24px;
            cursor: pointer;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .ImageItem:hover .animationItem {
            opacity: 1;
          }
          .animationItem {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            height: 100%;
            width: 100%;
            opacity: 0;
            transition: 0.5s ease;
            background-color: #008cba;
            .link_icon {
              width: 46px;
              height: 46px;
              img {
                width: 100%;
                height: 100%;
              }
            }
            .title {
              font-size: 18px;
              font-family: NotoSansHans-Medium, NotoSansHans;
              font-weight: 500;
              color: #ffffff;
              padding: 19px 0;
            }
            .dsrc {
              font-size: 14px;
              font-family: NotoSansHans-Regular, NotoSansHans;
              font-weight: 400;
              color: #ffffff;
              padding: 0 10px;
              box-sizing: border-box;
              line-height: 22px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3;
              word-break: break-all;
            }
          }
        }
      }
    }
  }
}
.Product-introduction{
  width: calc(1200px - 304px);
}
.Product-title{
  font-size: 30px;
  font-family: NotoSansHans-Regular, NotoSansHans;
  font-weight: 400;
  color: #333333;
  line-height: 45px;
  letter-spacing: 2px;
  padding: 30px 0;
  border-bottom: 1px solid #E6E8ED;
}
.Product-main{
  padding: 30px 0;
}
.Product-item{
  display: flex;
  /* align-items: center; */
  margin-bottom: 10px;
  cursor: pointer;
}
.paginationBox{
  display: flex;
  justify-content: center;
  padding: 30px 0;
}
.Product-image{
  width: 80px;
  height: 80px;
  margin-right: 22px;
}
.Product-image>img{
  width: 100%;
  height: 100%;
}
.Product-right{
  width: calc(100% - 102px);
  padding: 7px 0;
  border-bottom: 1px solid #E6E8ED;
}
.Product-name{
  font-size: 18px;
  font-family: NotoSansHans-Medium, NotoSansHans;
  font-weight: 500;
  color: #333333;
  line-height: 27px;
  letter-spacing: 2px;
  margin-bottom: 5px;
}
.Product-dsc{
  font-size: 14px;
  font-family: NotoSansHans-Regular, NotoSansHans;
  font-weight: 400;
  color: #333333;
  line-height: 24px;
  letter-spacing: 2px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.ImageItemWrap{
  margin-right: 24px;
}
.ImageItemWrap:nth-child(3n+3){
  margin-right: 0;
}
.ServiceSupport{
  .ProductImge{
    width: 100%;
    height: 280px;
    // background: lightcoral;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .introductionBox{
    width: 100%;
    height: auto;
    margin-bottom: 148px;
    .introduction-mian{
      display: flex;
      width: 1200px;
      margin: 0 auto;
      .introduction_L{
        width: 204px;
        height: auto;
        margin-right: 100px;
        .introductiontitle{
          width: 203px;
          height: 80px;
          background: #1373cf;
          font-size: 24px;
          font-family: NotoSansHans-Regular, NotoSansHans;
          font-weight: 400;
          color: #FFFFFF;
          text-align: center;
          line-height: 80px;
          cursor: pointer;
        }
        .introductionItem{
          /deep/.el-submenu__title i{
            color:#fff;
          }
          /deep/.el-menu-item{
            background: #9FC6EA !important;
          }
        }
        .current{
          background: #1373CF;
          opacity: 0.5;
        }
      }
      .introduction_r{
        width: calc(1200px - 304px);
        .introduction_nameBox{
          display: flex;
          justify-content: space-between;
          align-items: center;
           padding: 30px 0;
          // margin-bottom: 30px;
          border-bottom: 1px solid #E6E8ED;
          .introduction_name{
          font-size: 30px;
          font-family: NotoSansHans-Regular, NotoSansHans;
          font-weight: 400;
          color: #333333;
        }
          .inputBox{
            width: 360px;
            height: 36px;
            // background: #FFFFFF;
            border-radius: 4px;
            // border: 1px solid #1373CF;
          }
        }
        .introduction_cont{
          .Customer_title{
            font-size: 18px;
            font-family: NotoSansHans-Medium, NotoSansHans;
            font-weight: 500;
            color: #333333;
          }
          .Customertext{
            font-size: 14px;
            font-family: NotoSansHans-Regular, NotoSansHans;
            font-weight: 400;
            color: #333333;
            line-height: 21px;
            padding: 30px 0;
            border-bottom: 1px solid #E6E8ED;
          }
          .Case-zoneBox{
            // padding: 10px 0;
            .Image_titleBox{
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 20px 0;
              .Image_title{
                font-size: 18px;
                font-family: NotoSansHans-Medium, NotoSansHans;
                font-weight: 500;
                color: #333333; 
              }
              .moretext{
                font-size: 14px;
                font-family: NotoSansHans-Regular, NotoSansHans;
                font-weight: 400;
                color: #1373CF;
                cursor: pointer;
              }
            }
            .Product_ImageBox{
              display: flex;
              flex-wrap: wrap;
              // justify-content: space-between;
              align-items: center;
              .ImageItem{
                position: relative;
                width: 282px;
                height: 223px;
                background: #cfad13;
                margin-bottom: 24px;
                cursor: pointer;
                img{
                  width: 100%;
                  height: 100%;
                }
              }
              .ImageItem:hover .animationItem{
                // background: rgba(19, 115, 207, 0.68);
                opacity: 0.68;
              }
              .animationItem{
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                height: 100%;
                width: 100%;
                opacity: 0;
                transition: .5s ease;
                // background: rgba(19, 115, 207, 0);
                background-color: #008CBA;
                .link_icon{
                  width: 46px;
                  height: 46px;
                  img{
                    width: 100%;
                    height: 100%;
                  }
                }
                .title{
                  font-size: 18px;
                  font-family: NotoSansHans-Medium, NotoSansHans;
                  font-weight: 500;
                  color: #FFFFFF;
                  padding: 19px 0;
                }
                .dsrc{
                  font-size: 14px;
                  font-family: NotoSansHans-Regular, NotoSansHans;
                  font-weight: 400;
                  color: #FFFFFF;
                  padding: 0 10px;
                  box-sizing: border-box;
                  line-height: 22px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-box-orient: vertical;
                  -webkit-line-clamp: 3;
                  word-break: break-all;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>